"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _APIs = require("../../constants/APIs");
var _labelConsts = require("../../constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("../../logics/stringUtil"));
var _coreInfoBarActions = require("../../reducers/coreInfoBarActions");
var _CLink = _interopRequireDefault(require("../materials/CLink"));
var _CallAPI = require("../system/CallAPI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 *ドキュメントリンク（ファイルのダウンロード）
 * @prop {string} [dispFileNm] - 表示用ファイル名
 * @prop {string} fileNm - ファイル名
 */
class ManualLink extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", () => {
      const {
        intl,
        openInfoBar,
        callAPIRawResponse,
        fileNm
      } = this.props;
      const sendData = {
        fileNm: fileNm
      };
      callAPIRawResponse(_APIs.MANUAL_DOWNLOAD, sendData).then(response => response.blob()).then(blob => {
        if (blob.size > 0) {
          let anchor = document.createElement('a');
          anchor.download = fileNm;
          anchor.href = window.URL.createObjectURL(blob);
          anchor.click();
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
            id: _labelConsts.LABEL.CORE_FILE_NOT_FOUND_MESSAGE
          }));
        }
      });
    });
  }
  render() {
    const {
      dispFileNm
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CLink.default, {
      onClick: this.onClick
    }, _stringUtil.default.emptyToHyphen(dispFileNm)));
  }
}
ManualLink.propTypes = {
  dispFileNm: _propTypes.default.string,
  fileNm: _propTypes.default.string.isRequired
};
const mapDispatchToProps = dispatch => {
  return {
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(ManualLink)));